import React from 'react'
import cx from 'classnames'
import Icon from 'components/Icon'
import styles from './Radio.sass'

interface RadioProps {
  selected?: boolean
  size?: number
  completed?: boolean
}

export default function Radio({ selected, completed, size = 24 }: RadioProps) {
  const iconSize = size * 0.69

  return (
    <div
      className={cx(styles.root, selected && styles.selected)}
      style={{ width: size, height: size }}
    >
      {completed ? (
        <Icon size={iconSize} color="var(--brand-primary)" name="checkmark" />
      ) : (
        <input type="radio" className={styles.radio} checked={selected} />
      )}
    </div>
  )
}
